export default "__VITE_ASSET__75359511__"